import BaseFormModel from './base-form-model';
import modelsStore from '@/lib/services/models-store';

import defineProperty from '@/lib/helpers/define-property';
import defineMethodsChildren from '@/lib/helpers/define-methods-children';

import {
  STEP_TYPE,
  FIELDSET_TYPE,
} from '@/lib/constants/model-types';

class Step extends BaseFormModel {
  constructor(
    component,
    {
      name,
      uiProps,
      customFlow,
      mainAction,
    },
  ) {
    super(component, uiProps);

    defineProperty(this, 'name');
    this.name = name;

    defineProperty(this, 'customFlow');
    this.customFlow = customFlow;

    defineProperty(this, 'mainAction');
    this.mainAction = mainAction;

    defineMethodsChildren(this, {
      selfName: Step.$modelName,
      namePlural: 'fieldsets',
      nameSingular: 'fieldset',
      type: FIELDSET_TYPE,
    });
  }

  findByName(name) {
    return this.fieldsets.find(fieldset => fieldset.name === name);
  }

  get isEditable() {
    return this.form.isEditable
      && this.transactionalBlockers.length === 0;
  }

  get isLoading() {
    return this.loaders.length > 0
      || this.fieldsets.some(fieldset => fieldset.isLoading);
  }

  get fields() {
    const { fieldsets } = this;
    const fields = fieldsets.flatMap(f => f.fields);

    return fields;
  }

  get allFields() {
    const { allFieldsets } = this;
    const fields = allFieldsets.flatMap(f => f.allFields);

    return fields;
  }

  get isValid() {
    const { fieldsets } = this;

    return fieldsets.every(fieldset => fieldset.isValid);
  }

  get isInvalid() {
    const { fieldsets } = this;

    return fieldsets.some(fieldset => fieldset.isInvalid);
  }

  static get $modelType() {
    return STEP_TYPE;
  }

  static get $modelName() {
    return 'step';
  }

  static get $parentName() {
    return 'form';
  }
}

modelsStore.registerClass(Step);

export default Step;
